export const MerchantActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    ADD_MERCHANT_REQUEST: 'ADD_MERCHANT_REQUEST',
    ADD_MERCHANT_REQUEST_SUCCESS: 'ADD_MERCHANT_REQUEST_SUCCESS',
    ADD_MERCHANT_REQUEST_ERROR: 'ADD_MERCHANT_REQUEST_ERROR',
    ADD_MERCHANT_REQUEST_STATUS: 'ADD_MERCHANT_REQUEST_STATUS',

    MERCHANT_LIST_REQUEST: 'MERCHANT_LIST_REQUEST',
    MERCHANT_LIST_REQUEST_SUCCESS: 'MERCHANT_LIST_REQUEST_SUCCESS',
    MERCHANT_LIST_REQUEST_ERROR: 'MERCHANT_LIST_REQUEST_ERROR',

    MERCHANT_DETAIL_REQUEST: 'MERCHANT_DETAIL_REQUEST',
    MERCHANT_DETAIL_REQUEST_SUCCESS: 'MERCHANT_DETAIL_REQUEST_SUCCESS',
    MERCHANT_DETAIL_REQUEST_ERROR: 'MERCHANT_DETAIL_REQUEST_ERROR',

    UPDATE_MERCHANT_DETAIL_REQUEST: 'UPDATE_MERCHANT_DETAIL_REQUEST',
    UPDATE_MERCHANT_DETAIL_REQUEST_SUCCESS: 'UPDATE_MERCHANT_DETAIL_REQUEST_SUCCESS',
    UPDATE_MERCHANT_DETAIL_REQUEST_ERROR: 'UPDATE_MERCHANT_DETAIL_REQUEST_ERROR',
    UPDATE_MERCHANT_DETAIL_REQUEST_STATUS: 'UPDATE_MERCHANT_DETAIL_REQUEST_STATUS'
}
